<template>
  <div>
    <div class="row mt-4">
      <!-- Main Content Column -->
      <div class="col-xl-6 col-lg-6 col-sm-6 col-6 mb-4">
        <!-- Search Panel -->
        <div class="dashboard__panel mb-4">
          <SearchAccountOrUser
            class="dashboard__search-panel"
            @account-selected="selectedAccountId = $event"
          />
        </div>
        <!-- RPC Chart -->
        <RpcCategoryChart 
          v-show="false"
          :account-id="selectedAccountId" 
          @update:account-id="selectedAccountId = $event" 
        />
      </div>
      
      <!-- Right Sidebar Column -->
      <div class="col-xl-6 col-lg-6 col-sm-6 col-6 mb-4">
        <!-- Revenue Chart (Mission to $1M) -->
        <RevenueChart class="mb-3" />
        <!-- Traffic Quality Chart -->
        <TrafficQualityChart />
      </div>
    </div>
  </div>
</template>

<script>
import SearchAccountOrUser from '@/components/SearchAccountOrUser.vue'
import RevenueChart from '@/components/RevenueChart.vue'
import TrafficQualityChart from '@/components/TrafficQualityChart.vue'
import RpcCategoryChart from '@/components/RpcCategoryChart.vue'

export default {
  name: 'Dashboard',
  title: 'Dashboard',

  components: {
    SearchAccountOrUser,
    RevenueChart,
    TrafficQualityChart,
    RpcCategoryChart
  },

  data() {
    return {
      selectedAccountId: null
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard__panel {
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.dashboard__search-panel {
  max-height: 60vh;
  min-height: 10vh;
  overflow: auto;
}
</style>
